<template>
  <el-row class="cs-contentContainer cs-suppStudentInfo-container">
    <el-col :span="4" class="cs-contentContainer-registerLeft">
      <div>&nbsp;</div>
    </el-col>
    <el-col :span="16" class="cs-fullHeight cs-suppStudentInfo-middleContainer">
   
        <el-form  class="cs-suppStudentInfo-form"  label-width="100px" ref="supplementForm">
      
            <el-row class="margin-bottom-2px backgroud-white cs-register-title">
              <el-col :span="24" class="su-title">
                <span>合同签署</span>
              </el-col>
            </el-row>
            <el-row class="backgroud-white cs-register-main">
              <el-col :span="24">
                <div class="contractviewer-container">
                  <contractViewer v-on:contractSigned="onContractSigned"></contractViewer>
                </div>
              </el-col>
            </el-row>
            <el-row class="backgroud-gray su-left-align cs-register-foot">
              <el-col :span="24">
                <span><i class="el-icon-warning"></i>&nbsp;您需要签署所有待签署的合同之后才能使用系统.</span>
              </el-col>
            </el-row>
            <el-row class="hidden-xs-only cs-register-bottom backgroud-black text-center">
              <el-col>
                <footer>
                  <small>Powered by Speed Up Education Inc.</small>
                </footer>
              </el-col>
            </el-row>
        </el-form>
    </el-col>
    <el-col :span="4" class="cs-contentContainer-registerRight">
      <div>&nbsp;</div>
    </el-col>
  </el-row>
</template>
<style lang="scss" scoped>
body .cs-wrapper .cs-content .cs-suppStudentInfo-container{
  height: 100%;
  .cs-suppStudentInfo-middleContainer{
    height: 100%;
    .cs-suppStudentInfo-form{
      height: 100%;
    }
  }
}

.contractviewer-container {
  padding: 20px;
}

.supplementForm {
  text-align: left;
}
.grid-content {
  margin-top: 26px;
}
.su-title {
  font-size: 20px;
  font-weight: bold;
  margin-top: 35px;
  text-align: center;
}
.el-form-item {
  margin-bottom: 10px;

  &.is-required {
    label {
      &:before {
        content: "";
      }
    }
  }
}
.cs-register-main{
  min-height: 70%;
  z-index: 99;
}
.cs-register-foot {
  padding: 5px 0 5px 15px;
  font-size: 80%;
}
.cs-register-wechat-container{
  text-align: right;
}
.cs-register-btn-container {
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: left;

  .cs-register-btn {
    display: inline-block;
    vertical-align: middle;
    float: right;
  }
}

.errorMessageContainer {
  display: inline-block;
  vertical-align: middle;
  min-height: 56px;

  .cs-register-alert {
    padding: 0 10px;
  }
}

.cs-register-bottom{
  height:60px;
  footer{
    line-height: 60px;
  }
}
</style>

<script>
import { setStore } from '@/config/mUtils';

export default {
  components: {
    contractViewer: () => import("../components/contractViewer")
  },
  data() {
    return {};
  },
  async created() {
  },
  methods: {
    onContractSigned() {
      setStore("user_student_hasUnsignedContracts", 0);
      location.href = "/appointmentList";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/pendingContracts.vue